import store from "@/store";

export default {
  async getInstanceLevelUserGroups() {
    const response = await ApiClient.get("api/user-groups", {
      withCredentials: true,
    });
    return response.data;
  },
  async getUserGroups() {
    const t = store.getters["tenants/currentTenantId"];
    const response = await ApiClient.get(`api/${t}/user-groups`, {
      withCredentials: true,
    });
    return response.data;
  },
  submitUserGroup(group) {
    const t = store.getters["tenants/currentTenantId"];
    return ApiClient.put(`api/${t}/user-groups`, group, {
      withCredentials: true,
    });
  },
  deleteUserGroup(groupId) {
    const t = store.getters["tenants/currentTenantId"];
    return ApiClient.delete(`api/${t}/user-groups/${groupId}`, {
      withCredentials: true,
    });
  },
};
